import { Alert } from "react-native";
import { openSettings, RESULTS } from "react-native-permissions";
import { requestFileSharePermissions } from "@utils/Permissions";

// On API 33+ there are no storage permissions for file sharing — the OS
// grants access implicitly. requestFileSharePermissions() returns
// { granted: true } immediately on those devices, so no prompt fires.
export default async (...args) => {
  const executableFunc = args[0];
  const executableFuncArgs = args.slice(1);

  try {
    const { granted, statuses } = await requestFileSharePermissions();

    if (granted) {
      executableFunc.apply(null, executableFuncArgs);
      return;
    }

    const isBlocked = Object.values(statuses).some(
      (s) => s === RESULTS.BLOCKED,
    );

    if (isBlocked) {
      Alert.alert(
        "Go to Settings",
        "CityMall को whatsapp शेयर करने के लिये आपके storage की परमिशन चाहिए |",
        [
          {
            text: "OK",
            onPress: () =>
              openSettings().catch(() => console.log("cannot open settings")),
          },
        ],
        { cancelable: true },
      );
      return;
    }

    return Promise.reject("User won't give us permission");
  } catch (e) {
    console.log(e);
  }
};
